<template>

  <div class="Fans">
    <!-- Swiper -->
    <div v-swiper:mySwiper="swiperOption" class="swiper-container"
         ref="mySwiper" id="my-handle"
         v-if="status == 1"
    >
      <div class="swiper-wrapper">
        <section class="swiper-slide section1 FANS_MAP">
          <FansHeader class="FansHeader"
                      logoColor="_white"
          />

          <div class="inner_center">
            <div class="section-headline ani"
                 swiper-animate-effect="fadeInUp"
                 swiper-animate-duration="0.3s"
                 swiper-animate-delay="0.3s"
            >
              创作从未如此简单 <br>
              探索奇幻世界
            </div>

            <div class="section-handle ani"
                 swiper-animate-effect="fadeInUp"
                 swiper-animate-duration="0.3s"
                 swiper-animate-delay="0.5s">
              <a
                class="handle-btn handle-left"
                :href="FANS.COMMON.HEADER_NAV[0].link"
                target="_blank"
              >
                创意需求池
              </a>
              <a
                class="handle-btn handle-right"
                :href="FANS.COMMON.HEADER_NAV[0].link"
                target="_blank">
                我要提需求
              </a>
            </div>
          </div>


        </section>
        <section class="swiper-slide section2 FANS_MAP">
          <div class="inner_center">
            <div class="section-headline ani"
                 swiper-animate-effect="bounceInLeft"
                 swiper-animate-duration="1s"
                 swiper-animate-delay="0s"
            >
              打破会员传统定义 <br>
              诠释宠粉新概念
            </div>

            <div class="section-handle ani"
                 swiper-animate-effect="bounceInLeft"
                 swiper-animate-duration="1s"
                 swiper-animate-delay="0s"
            >
<!--              <div @click="wait"
                class="handle-btn handle-left" >
                签到有礼
              </div>-->
              <a :href="CALENDAR" target="_blank"
                   class="handle-btn handle-left" >
                营销日历自定义日程
              </a>
<!--              <div
                @click="wait"
                class="handle-btn handle-right" >
                拉新得潮币
              </div>-->
            </div>
          </div>
        </section>
        <section class="swiper-slide section3 FANS_MAP">

          <div class="inner_center">
            <div class="section-headline ani"
                 swiper-animate-effect="bounceInRight"
                 swiper-animate-duration="0.5s"
                 swiper-animate-delay="0s"
            >
              听说这个世界有很多惊喜 <br>
              你的愿望是什么
            </div>

            <div class="section-handle ani"
                 swiper-animate-effect="bounceInRight"
                 swiper-animate-duration="0.5s"
                 swiper-animate-delay="0s"
            >
              <div class="handle-btn handle-left" @click="wait">
                愿望清单
              </div>
              <div class="handle-btn handle-right" @click="wait">
                我的愿望
              </div>
            </div>
          </div>

        </section>
        <section class="swiper-slide section4 FANS_MAP">

          <div class="inner_center">
            <div class="section-headline ani"
                 swiper-animate-effect="fadeInUp"
                 swiper-animate-duration="0.5s"
                 swiper-animate-delay="0s">
              专属智能IP形象 <br>
              萌趣贴心敬请期待
            </div>

            <div class="section-handle ani"
                 swiper-animate-effect="fadeInUp"
                 swiper-animate-duration="0.5s"
                 swiper-animate-delay="0s">
              <div class="handle-btn handle-left" @click="wait">
                了解详情
              </div>
              <div class="handle-btn handle-right" @click="wait">
                立即领取
              </div>
            </div>
          </div>

        </section>
        <section class="swiper-slide section5 FANS_MAP">
          <div class="inner_center">
            <div class="title ani" swiper-animate-effect="rollIn">VIP客户服务</div>
            <div class="server-content">
              <div class="layout_left ani" swiper-animate-effect="bounceInLeft">
                <div class="customer-service server-item">
                  <div class="server-item-title">专属客户服务</div>
                  <div class="server-item-desc">我们的专属顾问乐意为您服务</div>
                  <a class="server-item-more"
                     :href="SERVICE_LINK"
                     target="_blank"
                  >了解更多 ></a>
                </div>
                <div class="custom-service server-item">
                  <div class="server-item-title">定制服务</div>
                  <div class="server-item-desc">潮国创意致力于帮助解决会员客户问题</div>
                  <a class="server-item-more"
                     :href="FANS.COMMON.HEADER_NAV[0].link"
                     target="_blank"
                     >了解更多
                    ></a>
                </div>
              </div>
              <div class="layout_right ani" swiper-animate-effect="bounceInRight">
                <div class="vip-gift server-item">
                  <div class="server-item-title">会员礼物</div>
                  <div class="server-item-desc">所有让你开心、对你重要的东西 <br>
                    都值得被赋予仪式感
                  </div>
                  <a class="server-item-more"
                     :href="FANS.COMMON.HEADER_NAV[1].link"
                     target="_blank"
                  >了解更多 ></a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="swiper-slide section6">
          <Footer/>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import mixin from "@/pages/fans/common/mixin";
import _ from 'lodash'
import * as swiperAni from '@/assets/swiper.animate'
import {fnFlowStatistics, fnLogin, fnUser} from "@/fn";
import {FANS} from "~/constant/fans/FANS";
import {SERVICE_LINK} from "@/constant/_constant/CON_CONFIG";
import {CALENDAR} from "@/constant/_Public/Path";


export default {
  name: "Fans",
  // layout: "Footer",
  layout: "act",
  mixins: [mixin],
  components: {},
  data() {
    return {
      CALENDAR,
      swiperOption: {
        direction: "vertical",
        slidesPerView: 'auto',
        mousewheel: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        eventsTarged: '#my-handle',
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        loop: false, // 在此无效？？？？？
        on: {
          init() {
            swiperAni.swiperAnimateCache(this); //隐藏动画元素
            swiperAni.swiperAnimate(this); //初始化完成开始动画
          },
          slideChangeTransitionEnd(vo) {
            swiperAni.swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
          }
        },
      },
      status: 0,
      FANS,
      SERVICE_LINK
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.init();

    setTimeout(() => {
      this.status = 1
    }, 500)
  },
  methods: {
    init() {
      this.initWait();

      fnFlowStatistics.pageFlow('vipDemand')
    },

    initWait() {
      let handleBtn = document.getElementsByClassName('handle-btn');
      for (let i = 0; i < handleBtn.length; i++) {
        handleBtn[i].onclick = () => {
          this.$myNotify.show('敬请期待')
        }
      }
      let handleBtn2 = document.getElementsByClassName('server-item-more');
      for (let i = 0; i < handleBtn2.length; i++) {
        handleBtn2[i].onclick = () => {
          this.$myNotify.show('敬请期待')
        }
      }


    },

    wait() {
      this.$myNotify.show('敬请期待')
    },
  }
}
</script>


<style lang="scss" scoped>

.swiper-container {
  height: 100vh;
}

.fixed {
  position: fixed;
  top: 100px;
  left: 100px;
  z-index: 99;
  background-color: pink;
}

@mixin SectionItem(
  $headlineColor: white,
) {
  .section-headline {
    font-size: 60px;
    font-weight: bold;
    color: $headlineColor;
    line-height: 89px;
    letter-spacing: 4px;
    margin-bottom: 54px;
  }

  .section-handle {
    display: flex;

    .handle-btn {
      width: 186px;
      height: 56px;
      box-sizing: border-box;
      border-radius: 28px;
      border: 1px solid $headlineColor;
      color: $headlineColor;
      margin-right: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      @if $headlineColor == rgba(0, 0, 26, 1) {
        &:hover {
          background: #EDECF1;
          border-color: rgba(0, 0, 26, 0.06);
          border: none;
        }
      } @else {
        &:hover {
          background: rgba(255, 255, 255, 0.20);
          border-color: rgba(255, 255, 255, 0.20);
          border: none;
        }
      }

    }
  }


}

.Fans {

  .section1 {
    height: 950px !important;
    @include BgImage(100%, 950px, 'fans/section1.jpg?v=2', 1);
    @include SectionItem(white);
    position: relative;

    .inner_center {
      margin-top: 313px;
    }

    .FansHeader {
      @include Position(1, 5, 50%, 0px);
      transform: translateX(-50%);
      z-index: 99;

      /deep/ .bar {
        display: none !important;
      }

    }
  }

  .section2 {
    height: 740px !important;
    @include BgImage(100%, 740px, 'fans/section2.jpg', 1);
    @include SectionItem(rgba(0, 0, 26, 1));

    .inner_center {
      margin-top: 178px;
    }
  }

  .section3 {
    height: 740px !important;
    @include BgImage(100%, 740px, 'fans/section3.jpg?v=3', 1);
    @include SectionItem(white);

    .inner_center {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;
      margin-top: 178px;
      text-align: right;
    }
  }

  .section4 {
    height: 740px !important;
    @include BgImage(100%, 740px, 'fans/section4.jpg', 1);
    @include SectionItem(rgba(0, 0, 26, 1));

    .inner_center {
      margin-top: 178px;
    }
  }

  .section5 {
    width: 100%;
    height: 915px !important;
    padding: 100px 0 65px;
    box-sizing: border-box;


    .inner_center {

      .title {
        height: 66px;
        font-size: 50px;
        font-weight: bold;
        color: #00001A;
        line-height: 66px;
        letter-spacing: 7px;
        text-align: center;
        margin-bottom: 64px;
      }

      .server-content {
        display: flex;
        justify-content: space-between;

        .layout_left {
          .customer-service {
            width: 674px;
            height: 294px;
            margin-bottom: 32px;
            @include BgImage(705px, 294px, 'fans/customer-service.png?v=2')
          }

          .custom-service {
            width: 674px;
            height: 294px;
            @include BgImage(705px, 294px, 'fans/custom-service.png?v=2')
          }


          @include Screen(1) {
            .customer-service {
              @include BgImage(584px, 294px, 'fans/customer-service@small.png?v=2')
            }
            .custom-service {
              @include BgImage(584px, 294px, 'fans/custom-service@small.png?v=2')
            }
          }
        }

        .layout_right {
          .vip-gift {
            width: 674px;
            height: 620px;
            @include BgImage(705px, 620px, 'fans/vip-gift.png?v=2')
          }

          @include Screen(1) {
            .vip-gift {
              @include BgImage(584px, 620px, 'fans/vip-gift@small.png?v=2')
            }
          }

        }

        .server-item {
          padding: 80px 0 0 60px;
          box-sizing: border-box;

          .server-item-title {
            height: 47px;
            font-size: 36px;
            font-weight: bold;
            color: #00001A;
            line-height: 47px;
            letter-spacing: 1px;
          }

          .server-item-desc {
            font-size: 18px;
            color: #00001A;
            line-height: 30px;
            letter-spacing: 1px;
            margin: 8px 0 24px;
          }

          .server-item-more {
            font-size: 16px;
            color: #6969FF;
            line-height: 21px;

            @include ElementHover(#6969FF, '') {
              text-decoration: underline;
            }
          }

        }
      }
    }
  }

  .section6 {
    //height: 518px !important;
    background: #F5F6FA;
  }
}
</style>
